module.exports = __webpack_public_path__ + "img/close-x.354f5694.svg";